import { Stack, router } from 'expo-router';
import React from 'react';

import { OrderConfirmationHeader } from '../../components/app-header/cart-header';

export default () => {
  return (
    <Stack>
      <Stack.Screen
        name="[rbiOrderId]"
        options={{
          header: () => (
            <OrderConfirmationHeader href={router.canGoBack() ? '../' : '/'} title="My Order" />
          ),
        }}
      />
    </Stack>
  );
};
